import {useRouter} from "vue-router";

export default () => {
  const router = useRouter();
  const forceRedirectTo404 = () => {
    window.location.href = `/404${router.currentRoute.value.fullPath}`
  }
  return {forceRedirectTo404}
}
